import React, { useEffect, useState } from "react";
import { WifiSlash } from "@phosphor-icons/react";
import { useSettings } from "@/context/SettingsContext";
import { pick } from "@/lib/languages";

const OFFLINE = {
  en: "You are offline. Check your connection — the page will work again as soon as it is back.",
  fr: "Vous êtes hors connexion. Vérifiez votre réseau : la page refonctionnera dès le retour de la connexion.",
  es: "Estás sin conexión. Revisa tu red: la página volverá a funcionar en cuanto vuelva la conexión.",
  pt: "Está sem ligação. Verifique a sua rede: a página volta a funcionar assim que a ligação voltar.",
  ar: "أنت غير متصل بالإنترنت. تحقق من شبكتك: ستعمل الصفحة مجددًا فور عودة الاتصال.",
  zh: "您已离线。请检查网络连接，连接恢复后页面即可继续使用。",
};

/**
 * A thin band at the bottom of the screen while the phone or computer has no
 * network — in the Toukky apps above all, where a silent failure would look
 * like a broken app. It leaves by itself when the connection is back.
 */
export default function OfflineNotice() {
  const { lang } = useSettings();
  const [offline, setOffline] = useState(() => typeof navigator !== "undefined" && navigator.onLine === false);
  useEffect(() => {
    const down = () => setOffline(true);
    const up = () => setOffline(false);
    window.addEventListener("offline", down);
    window.addEventListener("online", up);
    return () => { window.removeEventListener("offline", down); window.removeEventListener("online", up); };
  }, []);
  if (!offline) return null;
  return (
    <div role="status" data-testid="offline-notice"
      className="fixed inset-x-0 bottom-0 z-offline flex items-center justify-center gap-2 bg-touki-dark-surface px-4 py-3 text-center text-sm font-medium text-white"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}>
      <WifiSlash size={18} weight="bold" aria-hidden="true" className="shrink-0" />
      <span>{pick(OFFLINE, lang)}</span>
    </div>
  );
}
